import useIsMobile from 'app/hooks/useIsMobile';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import NbrContentDesktop from './NbrContentDesktop';
import NbrContentMobile from './NbrContentMobile';
import { type NbrCtaProps } from './types';

const NbrCta = ({ suggestedArticle, onClick }: NbrCtaProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const dimensions = isMobile ? { width: 322, height: 67 } : { width: 302, height: 104 };

  return (
    <motion.button
      id="ostro-suggested-article-button"
      initial={{ opacity: 0, width: 0, height: 0 }}
      animate={{ opacity: 1, ...dimensions }}
      onClick={onClick}
      className="border-buttonColor border-buttonWidth rounded-[6px] overflow-hidden text-left"
      aria-label={t('aria_labels.open_article_button', { title: suggestedArticle.title })}
    >
      {isMobile ? (
        <NbrContentMobile suggestedArticle={suggestedArticle} />
      ) : (
        <NbrContentDesktop suggestedArticle={suggestedArticle} />
      )}
    </motion.button>
  );
};

export default NbrCta;
